import axios from './axios'
import { AvailabilityMap, InstructorAvailabilityDto, SetDayAvailabilityDto, ToggleAvailabilityDto } from './types'

export const getAvailabilityByMonth = (instructorId: string, month: string) => {
  return axios.get<InstructorAvailabilityDto[]>('/instructor-availability', {
    params: { instructorId, month },
  })
}

export const toggleAvailability = (data: ToggleAvailabilityDto) => {
  return axios.put<{ available: boolean }>('/instructor-availability', data)
}

export const setDayAvailability = (data: SetDayAvailabilityDto) => {
  return axios.put<InstructorAvailabilityDto[]>('/instructor-availability/day', data)
}

export const getAvailabilityByDate = (date: string) => {
  return axios.get<AvailabilityMap>('/instructor-availability/by-date', {
    params: { date },
  })
}
